import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import Navbar from './components/layout/Navbar'
import './App.css';
import { Alert } from './components/layout/Alert';
import { About } from './components/pages/About';
import User from './components/users/User';
import GithubState from './context/github/GithubState'
import AlertState from './context/alert/AlertState';
import { Home } from './components/pages/Home';
import { NotFound } from './components/pages/NotFound';

const App = () => {

  return (
    <GithubState>
      <AlertState>
        <Router>
          <div className = 'App'>
            <Navbar />
            <div className = "container">
            <Alert />
            <Switch>
              <Route exact path = '/' component = { Home }/>
              <Route exact path = '/about' component = { About } />
              <Route exact path = '/user/:login' component = { User }/>
              <Route component = { NotFound } />
            </Switch>

            </div>
          </div>
        </Router>
      </AlertState>
    </GithubState>
  );
}

export default App;
